import React from 'react'
import { Field } from 'redux-form'
import { pt, buildPropTypes } from 'common-data/proptypehelpers'
import { FieldLayoutBox } from './FieldLayoutBox'
import { FieldValueFormatter, FieldValueParser } from './FieldValueConverters'
import _ from 'common-tools/LodashHelper'
import clsx from 'clsx'

class RadioListBoxClass extends React.Component {
  static propTypes = buildPropTypes([

  ], {
    options: pt.array.isRequired,
    textProp: pt.string.isRequired,
    valueProp: pt.string.isRequired,
    queryFieldSetup: pt.shape({
      Name: pt.string,
      Operator: pt.string,
      Group: pt.string
    }),
    inline: pt.bool.isRequired
  })

  static defaultProps = {
    options: [],
    textProp: 'Text',
    valueProp: 'Value',
    inline: false
  }

  renderOptions (inline, options, textProp, valueProp, fieldProps) {
    const { value, onChange, name, testId, readonly } = fieldProps
    if (readonly) {
      const optionMatch = _.find(options, (o) => { return o[valueProp] === value }) || {}
      return <input data-tid={testId} readOnly name={`view${name}`} id={`view${name}`} value={optionMatch[textProp] || value} />
    } else {
      return (
        <div className={clsx(!inline && 'grid-x grid-padding-x small-up-1 medium-up-1 large-up-1')}>
          {_.map(options, (o, i) => {
            const valuePropValue = o[valueProp || 'Value']
            const textPropValue = o[textProp || 'Text']

            return inline
              ? <React.Fragment key={valuePropValue}><input data-tid={`${testId}_${i}`} type='radio' checked={valuePropValue === value} id={`${name}_${i}`} name={name} onChange={onChange}
                value={valuePropValue} inline={inline ? 'true' : 'false'} /><label htmlFor={`${name}_${i}`}>{textPropValue || valuePropValue}</label></React.Fragment>
              : <div className="cell" key={valuePropValue}><input data-tid={`${testId}_${i}`} type='radio' checked={valuePropValue === value} id={`${name}_${i}`} name={name} onChange={onChange}
                value={valuePropValue} inline={inline ? 'true' : 'false'} /><label htmlFor={`${name}_${i}`}>{textPropValue || valuePropValue}</label></div>
          })}
        </div>
      )
    }
  }

  render () {
    const { inline, options, textProp, valueProp, ...rest } = this.props

    return (
      <FieldLayoutBox {...rest}>
        {(fieldProps) => this.renderOptions(inline, options, textProp, valueProp, fieldProps)}
      </FieldLayoutBox>
    )
  }
};

export const RadioListBox = ({ parse, format, fieldType, name, namePrefix, ...rest }) => { return <Field name={namePrefix ? `${namePrefix}.${name}` : name} parse={fieldType ? FieldValueParser(fieldType) : parse} format={fieldType ? FieldValueFormatter(fieldType) : format} {...rest} component={RadioListBoxClass} /> } // eslint-disable-line
export default RadioListBox
